import { data_fold, getAddress } from "../api/common";
import { logConfig, logErr } from "../common/log";
import { clearStorage, setStorage, getStorage } from "@/common/utils";
import {
  getAreaDepartmentByLastId,
  getAreaDepartmentByLastCode,
} from "../common/utils";
const directProvinceList = ["110000", "120000", "310000", "500000"];
import config from "@/config";
const isKunMing = config.isKunMing;
function setGapTime() {
  const currentDate = new Date().getTime();
  const updateTime = currentDate + 100000;
  setStorage("updateStorageTime", "" + updateTime);
}
function isUpdate() {
  const currentDate = new Date().getTime();
  const updateTime = getStorage("updateStorageTime");
  return currentDate > updateTime;
}
export const getAreaOption = async function() {
  const sortArea = getStorage("sortArea");
  const sortAreaKeys = Object.keys(sortArea);
  const hasValue = sortAreaKeys.some((key: any) => {
    return !sortArea[key];
  });
  if (isUpdate() || !hasValue) {
    return data_fold().then((res: any) => {

      let { code, data, msg } = res.data;
      data = res.data.result;
      let filterAreaArr = [],
        centerData = [];
      if (code === 200) {
        logConfig("get current user address success");
        filterAreaArr = data.filter(
          (province: any) =>
            province.id !== "100000" &&
            !["台湾省", "香港特别行政区", "澳门特别行政区"].includes(
              province.name
            )
        );

        centerData = data.find((province: any) => province.id === "100000");
      } else {
        logErr("get current user address failed", msg);
      }
      logConfig("current all area:", data, centerData);
      setGapTime();
      setStorage("sortArea", { main: filterAreaArr, center: centerData });
      return { main: data, center: centerData };
    });
  }
  return sortArea;
};
interface CITY {
  id: string;
  name: string;
  provinceId: string;
  provinceName: string;
}
export const getDefaultCity = async (allArea: any) => {
  const defaultCity = {
    id: "120100",
    name: "津市",
    provinceId: "120000",
    provinceName: "天津市",
  };
  try {
    const { ip } = getStorage("returnCitySN");
    let { data: result } = await getAddress();
    let city = {};
    const _city = getAreaDepartmentByLastId(allArea, result.result);
    if (!_city) {
      return defaultCity;
    } else {
      return {
        id: _city.id,
        name: _city.name,
        provinceId: _city.parentId,
        provinceName: "",
        locationAddressCode: result.result,
      };
    }
  } catch (err) {
    logErr("get default city", err);
    return defaultCity;
  }
};
export const getCity = async (allArea: any) => {
  let city: CITY = {
    id: "120100",
    name: "天津市",
    provinceId: "120000",
    provinceName: "天津市",
  };
  if (!isKunMing) {
    city = await getDefaultCity(allArea);
  } else {
    city = {
      id: "530100",
      name: "昆明市",
      provinceId: "530000",
      provinceName: "云南省",
    };
  }
  logConfig("current address", city);
  return city;
};
export const getAreaProps = (allArea: any, cityId: any) => {
  console.log(cityId, " cityId");
  const city = getAreaDepartmentByLastCode(allArea, cityId);
  console.log(city, "city");
  const cityList: any[] = [];
  city.children.map((item: any) => {
    cityList.push(item.id);
    return item;
  });
  const props = {
    cityList: cityList,
    cityId: city.id,
    cityName: city.name,
    provinceId: city.parentId,
    provinceName: "",
  };
  return props;
};
